// src/utils/api.js
const apiUrl = 'https://api.zerodayops.com'; // Default to localhost for development

// Utility function to refresh the token
const refreshAccessToken = async () => {
    try {
        const response = await fetch(`${apiUrl}/api/auth/refresh-token`, {
            method: 'POST',
            credentials: 'include',  // Send cookies with the request
        });
    } catch (error) {
        console.error('Error refreshing access token:', error);
        return null;
    }
};

export const apiRequest = async (endpoint, options = {}) => {
    const url = `${apiUrl}${endpoint}`;

    // Make the API request
    const response = await fetch(url, {
        ...options,
        credentials: 'include', // Ensure cookies are sent with request
    });

    if (response.status === 401) {
        // Token might be expired, attempt to refresh it
        await refreshAccessToken();
        // Make the API request
        try {
            const response = await fetch(url, {
                ...options,
                credentials: 'include', // Ensure cookies are sent with request
            });
        } catch (error) {
            console.error('Error refreshing access token:', error);
            return null;
        }
    }
    return response;
};

export const apiRequestUA = async (endpoint, options = {}) => {
    const url = `${apiUrl}${endpoint}`;

    // Make the API request
    const response = await fetch(url, {
        ...options,
        credentials: 'include', // Ensure cookies are sent with request
    });

    return response;
};
